import { z } from "zod";

import { intIdCodec, intIdSchema } from "@/codecs/intId";

// TODO: union with a cohire question id, like nimbleAtsJobIdSchema
export const questionIdSchema = intIdSchema.brand<"QuestionId">();
export const coreQuestionIdCodec = intIdCodec(questionIdSchema);

export const videoLinkUrlSchema = z
  .url({ protocol: /^https?$/ })
  .brand<"VideoLinkUrl">();
